import * as React from 'react'
import { ALL_FILTERS_ON, countEventTypes } from '../../helpers/eventHelper.tsx'
import { IEvent } from '../../interfaces/types.ts'
import { useSnapshot } from 'valtio'
import { controlState } from '../../store/controlState.ts'

interface Props {
    onChange: (u: string[]) => void
    list: IEvent[]
}

export const EventFilter: React.FC<Props> = (props) => {
    const {onChange, list} = props
    const isMobile = useSnapshot(controlState).isOnMobileDevice

    const [selectedFilters, setSelectedFilters] = React.useState<string[]>(ALL_FILTERS_ON)

    // Calculate event counts directly from props instead of using useEffect
    const counts = React.useMemo(() => {
        if (list) {
            return countEventTypes(list)
        }
        return { powerCount: 0, safeCount: 0, commandCount: 0, chargerCount: 0 }
    }, [list])

    const { powerCount, safeCount, commandCount, chargerCount } = counts

    const FilterTypes = [
        {name: 'Power Events', type: 'powerEvents', count: powerCount, on: false},
        {name: 'Charger Events', type: 'chargerEvents', count: chargerCount, on: false},
        {name: 'Safe Zone Events', type: 'safeZoneEvents', count: safeCount, on: false},
        {name: 'Gibi Commands', type: 'commandEvents', count: commandCount, on: false},
    ]

    const select = (
        type: string
    ) => {
        let update
        if (selectedFilters.includes(type)) {
            update = selectedFilters.filter(f => f !== type)
        } else {
            update = selectedFilters.slice(0)
            update.push(type)
        }
        setSelectedFilters(update)
        onChange(update)
    }
    return (
        <div className={`flex flex-wrap gap-2 px-3 py-2 ${isMobile ? 'justify-center' : 'justify-around'}`}>
            {FilterTypes.map(f => {
                const selected = selectedFilters.includes(f.type)
                return (
                    <button
                        key={f.name}
                        onClick={() => select(f.type)}
                        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border-2 text-sm font-semibold transition-colors cursor-pointer
                            ${selected
                                ? 'bg-primary border-primary text-primary-content'
                                : 'bg-transparent border-primary text-primary opacity-50'
                            }`}
                    >
                        {selected && <span className={'text-xs'}>✓</span>}
                        {f.name}
                    </button>
                )
            })}
        </div>
    )
}
